import { Dimensions, Platform } from "react-native"

export const isPlatformMobile = (): boolean =>
    Platform.OS !== "web" || Dimensions.get("window").width < 600
